import { DocumentParser, ParsedDocument, ScanContext } from '../core/types';

/** Fallback: any QR that no document parser claimed (plain text or URL). */
export class TextParser implements DocumentParser {
  readonly id = 'text';
  readonly label = 'Text / URL';

  detect(ctx: ScanContext): boolean {
    return ctx.symbols.length > 0 && ctx.symbols[0].text.length > 0;
  }

  parse(ctx: ScanContext): ParsedDocument {
    const text = ctx.symbols[0].text;
    const isUrl = /^https?:\/\//i.test(text);
    return {
      kind: 'text',
      title: isUrl ? 'URL' : 'Text',
      country: '',
      parser: this.id,
      fields: [{ label: isUrl ? 'URL' : 'Content', value: text }],
      raw: text,
    };
  }
}
